export const createWorkerFunc = () => {
    const temp = self;
    let timer = null;
    const onlineUrl = 'https://ads.popin.cc/platform/api/campaignManager/version';

    // 请求前先在主线程合成md5值
    function beforeDoFetch(config) {
        temp.postMessage({ type: 'getAuthorization', config });
    };

    // 开始轮询
    function startInterval(config) {
        destroyInterval();
        timer = setInterval(
            () => beforeDoFetch(config),
            60000
        );
    };

    // 停止轮询
    function destroyInterval() {
        timer && clearInterval(timer);
        timer = null;
    };

    const doFetch = (config) => {
        const { url, timestamp, authorization, email } = config;
        const params = { timestamp, authorization, email };
        fetch((url || onlineUrl), {
            method: 'GET',
            mode: 'same-origin',
            credentials: 'same-origin',
            headers: new Headers({
                'Content-Type': 'application/json',
                Timestamp: timestamp,
                Authorization: authorization
            })
        }).then(res => {
            if (!res.ok) {
                const {status, statusText} = res;
                const errorInfo = JSON.stringify({status, statusText});
                throw new Error(errorInfo);
            }
            return res.json();
        }).then(response => {
            if (!response) return;
            const {code, data, msg} = response;
            if (code === 0 && data) {
                temp.postMessage({ type: 'success', data: Object.assign({}, data, config) });
            } else {
                if (msg !== 'msn.backendMsg.noPermission') {
                    temp.postMessage({ type: 'fail', msg: msg || 'code is error', params });
                }
            }
        }).catch(error => {
            temp.postMessage({ type: 'fail', msg: error, params });
        });
    };

    temp.onmessage = (event) => {
        if (event?.data) {
            const {action, config} = event.data;
            config.action = action;
            if (action === 'doFetch') {
                doFetch(config);
            } else if (action === 'init') {
                beforeDoFetch(config);
            } else if (action === 'start') {
                startInterval(config);
            } else {
                destroyInterval();
            }
        }
    };
};


